import React from 'react';
import SvgIcon from './svgIcon';

const svgLineChart = props => {
  return (
    <SvgIcon width={32.76} height={21.127} {...props}>
        <g
          transform="translate(1.009 1.001)"
          strokeLinejoin="round"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2px"
        >
          <circle
            cx="2.473"
            cy="2.473"
            r="2.473"
            transform="translate(8.938 2.473)"
          />
          <path
            d="M18.413 11.933a2.473 2.473 0 1 1-2.656-2.275 2.474 2.474 0 0 1 2.656 2.275z"
            transform="translate(3.29 4.528)"
          />
          <path
            d="M25.139 3.282a2.473 2.473 0 1 1-2.656-2.275 2.472 2.472 0 0 1 2.656 2.275z"
            transform="translate(5.604 -.999)"
          />
          <path
            d="M5.939 10.552a2.473 2.473 0 1 1-2.656-2.275 2.472 2.472 0 0 1 2.656 2.275z"
            transform="translate(-1 2.329)"
          />
          <path
            transform="translate(4.414 6.495)"
            d="M0 4.384 4.384 0"
          />
          <path
            d="m0 0 4.585 6.792"
            transform="translate(13.183 7.226)"
          />
          <path
            d="m16.395 13.678 5.935-8.622z"
            transform="translate(4.333 .046)"
          />
        </g>
    </SvgIcon>
  );
};

export default svgLineChart;
